module.exports = __webpack_public_path__ + "static/img/info01@2x.9b416e52.png";